import { createAsyncThunk, createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { ntxAPI } from '@API/axiosNeatex';
import type { InvAllocateModels, InvAllocateByIdModels } from './InvAllocateModels';
import type { APIResponse } from '@store/Shared/shared';
// import { TransactionTypesModels } from '../SharedModels';

export const addAllocateTransactions = createAsyncThunk(
  'InvAllocate/addAllocateTransactions',
  async (item: any, { rejectWithValue }) => {
    try {
      // console.log(JSON.stringify(item));

      // debugger
      const { data } = await ntxAPI.post('InvAllocate/AddAllocateTransactions', item);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateAllocateTransactions = createAsyncThunk(
  'InvAllocate/updateAllocateTransactions',
  async (item: any, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.post('InvAllocate/UpdateAllocateTransactions', item);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getTransactionsAllocateList = createAsyncThunk(
  'InvAllocate/getTransactionsAllocateList',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.get('InvAllocate/GetTransactionsAllocateList');
      if (data?.succeeded) {
        //===
        return data.data;
      } else {
        return rejectWithValue(data.message);
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getAllocateTransactionsById = createAsyncThunk(
  'InvAllocate/getAllocateTransactionsById',
  async (id: string, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.get(`InvAllocate/GetAllocateTransactionsById?Id=${id}`);
      if (data?.succeeded) {
        // ===
        return data.data;
      } else {
        return rejectWithValue(data?.message || 'هناك خطأ');
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const addMaterialTransactionsAllocateLine = createAsyncThunk(
  'InvAllocate/addMaterialTransactionsAllocateLine',
  async (item: any, { rejectWithValue }) => {
    try {
      // console.log(JSON.stringify(item));

      // debugger
      const { data } = await ntxAPI.post('InvAllocate/AddMaterialTransactionsAllocateLine', item);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);
export const deleteMaterialTransactionsAllocate = createAsyncThunk(
  'InvAllocate/deleteMaterialTransactionsAllocate',
  async (transactionId: string, { rejectWithValue }) => {
    try {
      // console.log(JSON.stringify(item));

      // debugger
      const { data } = await ntxAPI.post<APIResponse<boolean>>(
        `InvAllocate/DeleteMaterialTransactionsAllocate?TransactionId=${transactionId}`
      );
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);
export const deleteMaterialTransactionsAllocateLine = createAsyncThunk(
  'InvAllocate/deleteMaterialTransactionsAllocateLine',
  async (
    { transactionId, transactionLineId }: { transactionId: string; transactionLineId: string },
    { rejectWithValue }
  ) => {
    try {
      // debugger
      const { data } = await ntxAPI.post<APIResponse<boolean>>(
        `InvAllocate/DeleteMaterialTransactionsAllocateLine?TransactionId=${transactionId}&TransactionLineId=${transactionLineId}`
      );
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

const initialState: {
  InvAllocateList: InvAllocateModels[];
  InvAllocateById: InvAllocateByIdModels;
  loading: boolean;
  error: any | null;
} = {
  InvAllocateList: [],
  InvAllocateById: {} as InvAllocateByIdModels,
  loading: false,
  error: null
};

const InvAllocateSlice = createSlice({
  name: 'InvAllocate',
  initialState,
  reducers: {
    // cleanUpTransactionsQuotationById: (state) => {
    //   state.TransactionsQuotationById = {} as InvAllocateByIdModels;
    // },
  },
  extraReducers(builder) {
    builder

      .addCase(getTransactionsAllocateList.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        getTransactionsAllocateList.fulfilled,
        (state, action: PayloadAction<InvAllocateModels[]>) => {
          state.loading = false;
          state.InvAllocateList = action.payload;
        }
      )
      .addCase(getTransactionsAllocateList.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      })
      //!~~~~~~~~~~~~~~~~~~

      .addCase(getAllocateTransactionsById.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        getAllocateTransactionsById.fulfilled,
        (state, action: PayloadAction<InvAllocateByIdModels>) => {
          state.loading = false;
          state.InvAllocateById = action.payload;
        }
      )
      .addCase(getAllocateTransactionsById.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export default InvAllocateSlice.reducer;
